import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { RouteConstants } from '@core/constants/route.constants';
import { AsideService, TranslationService } from '@core/services';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, CommonModule, TranslateModule],
  templateUrl: './app.component.html',
})
export class AppComponent {
  //Strings
  title: string = 'GIP.PACKAGING.UI';
  constructor(
    private router: Router,
    private translationService: TranslationService,
  ) {
    this.translationService.setDefaultLang();
  }

  get isLoginPage(): boolean {
    return this.router.url.startsWith(RouteConstants.LOGIN_MODULE.LOGIN);
  }
}
